export const dedupeCsvKeys = ["dependent_steps", "force_integration_call"];
export const dedupeSubstringKeys = ["api_url"];
export const dedupeFilterKeys = ["filters"];
export const dedupeBlacklistedKeys = [
  "fieldType",
  "body",
  "field_tags",
  "name",
  "type"
];

export const dedupeArrayIndexRegEx = /^\d+$/;
export const dedupeRegexFilterTag = (tag: string) =>
  new RegExp(`^\\$${tag}(?!\\w)|\\$${tag}$`, "g");

export const dedupePrefix = "Copy of ";

// This cannot be __ because it collides with BE's advance filtering logic
// where they use __ as a separator and so field tags that contain __ in their
// tags end up throwing errors because it BE is not expecting __ in the query
// as part of the field tag itself
export const dedupeSeparator = "_DUP_";
